import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    --show-teaser: block;
    width: 150px;
    height: 270px;
  }

  .post-card {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    background-color: var(--sds-color-background-default-secondary);
  }

  .post-image {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .post-gradient-overlay {
    position: absolute;
    inset: 0;
    background:
      linear-gradient(187deg, rgb(17 17 17 / 0.8) 3.03%, rgb(17 17 17 / 0) 30.16%),
      linear-gradient(202deg, rgb(17 17 17 / 0) 25.48%, rgb(17 17 17 / 0.8) 74.88%);
  }

  .premium-badge {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 4px;
    background-color: var(--sds-color-background-warning-default);
    color: var(--sds-color-text-default-primary);
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-semibold);
  }

  .post-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
    z-index: 1;
  }

  .post-teaser {
    display: var(--show-teaser);
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-body-font-family);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.5;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .post-card:hover {
    transform: translateY(-2px);
    transition: transform 0.2s ease;
  }

  /* Dropdown */
  .menu {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;

    .menu-dots {
      color: var(--sds-color-white-1000);

      &:hover {
        color: var(--sds-color-icon-default-default);
      }
    }
  }

  /* Confirmation dialog styles */
  .unsaved-changes-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    align-items: center;
    wow-button {
      min-width: 250px;
      --wow-button-inner-width: 100%;
    }
  }

  .danger,
  .danger:hover {
    /* override wow-button background color */
    --sds-color-background-default-secondary: var(--sds-color-background-danger-default);
  }

  @media (max-width: 768px) {
    .worlds-grid {
      grid-template-columns: 1fr;
      padding: 12px;
      gap: 12px;
    }

    .filter-buttons {
      padding: 12px 12px 0 12px;
      gap: 8px;
    }

    .empty-state {
      padding: var(--sds-size-space-600);
    }
  }
`;
